import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { frameSizeList } from 'lib/api/media';
import {
  getHeadObj,
  makeRowColumn,
  converParameters,
  getHost,
} from 'lib/commonLib';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const FrameSize = (props) => {
  const { t } = useTranslation();

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    // 테스트 DB에서 데이터 조회 가능한 일자
    // sDate: '20211115',     // eDate: '20211115',
    prdtTpCode: '01',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const customized = {
    FRME_SIZE: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'FRME_SIZE');
        let content;
        let deviceType = !!rowObj['BNR_CODE']
          ? rowObj['BNR_CODE'].charAt(0)
          : '';
        const showWindowUrl = converParameters({
          url: getHost() + '/Frtb/media_admin/media_report.php',
          w_type: deviceType.toLowerCase(),
          bnr_code: rowObj['BNR_CODE'],
        });
        content = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['FRME_SIZE'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon="faExternalLink"
            toolTipTitle={t('프레임사이즈 현황')}
            // onClick={(e) => (window.top.location.href = showWindowUrl)}
            onClick={(e) => window.open(showWindowUrl, '_blank')}
          />
        );
        return !!rowObj['FRME_SIZE'] && content;
      },
    },
    BNR_CODE: { merged: true },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          usePltfomTpCodeFilter={false}
          useExternalFilter={false}
          useDisplayFilter={false}
        />
        <FilterCollection
          label={t('프레임 상품코드')}
          value={params.prdtTpCode}
          name="prdtTpCode"
          type="radio"
          params={params}
          list={[
            { label: '상품', value: '01' },
            { label: '비상품', value: '02' },
          ]}
          labelKey="label"
          valueKey="value"
          callBack={getParam}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={frameSizeList}
        customized={customized}
        useFetch={false}
      />
    </>
  );
};

export default withRouter(FrameSize);
